import { escape } from "lodash";

import xmlParser from "../utils/xml-parsers/ixprofiler-mortgagee";
import { getApiUrl } from "../utils/get-api-url";
import { track } from "../units/tracking";

const buildBody = (query: string, limit: string) => {
  const escapedQuery = escape(query);
  return `<ProfileRequest>
    <Subject typeId="mortgagee">
      <DataItem name="MortgageeName" value="${escapedQuery}"/>
      <DataItem name="ResultLimit" value="${limit}"/>
      <DataItem name="Position" value=""/>
      <DataItem name="KeyValue" value=""/>
    </Subject>
  </ProfileRequest>`;
};

export interface MortgageeSearchProps {
  query: string;
  limit?: string;
}

export const mortgageeSearch = ({
  query,
  limit = "30"
}: MortgageeSearchProps) => {
  const apiUrl = getApiUrl("ixprofiler");
  const fullUrl = `${apiUrl}/templates/Mortgagees`;

  return query
    ? fetch(fullUrl, {
        method: "POST",
        credentials: "include",
        headers: {
          "Cache-Control": "no-cache",
          "Content-Type": "application/xml",
          Accept: "application/xml"
        },
        body: buildBody(query, limit)
      })
        .then(response => response.text())
        .then(rawResponse => {
          if (!rawResponse) {
            throw new Error(
              "There was an error fetching mortgagees. Please try your search again."
            );
          }
          const parsed = xmlParser(rawResponse);
          track("Mortgagee Search", {
            query,
            matches: parsed.matches,
            deadend: !!(parsed.matches === 0)
          });
          return parsed;
        })
    : Promise.resolve({ error: "Please enter a search term", mortgagees: [] });
};
